import { styled } from 'baseui'

export const SMaskedInputOverrides = error => ({
  Root: {
    style: () => ({
      borderColor: error ? `#B30F16` : '',
      backgroundColor: error ? 'transparent' : 'white',
    }),
  },
  Input: {
    style: $disabled => ({
      color: 'black',
      fontSize: '16px',
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
      paddingBottom: '.125rem',
      borderColor: error ? '#B30F16' : '',
      backgroundColor: error || $disabled ? 'transparent' : 'white',
    }),
  },
  InputContainer: {
    style: {
      paddingTop: '0.625rem',
      backgroundColor: error ? 'transparent' : '',
    },
  },
  EndEnhancer: {
    style: () => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      paddingTop: '0.625rem',
      paddingLeft: '0',
      paddingRight: '0',
      paddingBottom: '0',
      backgroundColor: error ? 'transparent' : '',
    }),
  },
})

export const FloatingLabel = styled('div', () => ({
  position: 'absolute',
  top: '0.375rem',
  left: '0.5rem',
  height: '1rem',
  fontSize: '0.75rem',
  color: 'gray',
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
  backgroundColor: 'transparent',
}))
